export const projectsData = [
  {
    id: 1,
    projectName: "Project Pepperfry",
    projectDesc:
      "Pepperfry is an Indian online marketplace for furniture and home decor. Built website redesigned by UI team.",
    tags: ["Node.js", "mongoDB"],
    logos: [
      "fab fa-react",
      "fab fa-html5",
      "fab fa-js",
      "fas fa-database",
      "fab fa-node",
    ],
    code: "https://github.com/vcow10kar/pepperfry-client",
    demo: "https://pepperfry-client.vercel.app/",
    image:
      "https://camo.githubusercontent.com/9479e6eb5ef51638c1ac6e1993e5d7e8d69f0d226f92d1f24207af8c4249f3bc/68747470733a2f2f63646e2e686173686e6f64652e636f6d2f7265732f686173686e6f64652f696d6167652f75706c6f61642f76313633393931373238343438302f647648534c527272782e6a7065673f6175746f3d636f6d70726573732c666f726d617426666f726d61743d77656270",
  },
  {
    id: 2,
    projectName: "Project Netflix",
    projectDesc:
      "Netflix is a streaming service that offers a wide variety of award-winning TV shows, movies, anime, documentaries",
    tags: ["EJS", "Node.js", "mongoDB"],
    logos: ["fab fa-react", "fab fa-html5", "fab fa-js", "fab fa-css3"],
    code: "https://github.com/mukhiarambhu/Project-Netflix",
    demo: "https://project-netflix-brown.vercel.app/",
    image: "https://i.postimg.cc/Wpk72BNS/Capture.jpg",
  },
  {
    id: 3,
    projectName: "Project CodePen",
    projectDesc:
      "Codepen is social development environment for front-end designers and developers, where one can write html css and javascript and view outcone",
    tags: ["EJS", "Node.js", "mongoDB"],
    logos: [
      "fab fa-react",
      "fab fa-html5",
      "fab fa-js",
      "fab fa-css3",
      "fab fa-node",
    ],
    code: "https://github.com/mukhiarambhu/Project-Codepen",
    demo: "https://project-codepen.vercel.app/",
    image:
      "https://camo.githubusercontent.com/4a41d82a319feee732f04eeaf9403fc5a10baadd327a9506795a9d4ee14724be/68747470733a2f2f692e706f7374696d672e63632f313539536e37366d2f436170747572652e6a7067",
  },
  {
    id: 4,
    projectName: "Project Netmeds",
    projectDesc:
      "It is a team project, we used local storage for data handling,implemented signup, log in with OTP, search functionality, individual product page, category-wise page, cart, checkout page, ",
    tags: ["Html", "css", "javascript"],
    logos: ["fab fa-html5", "fab fa-css3", "fab fa-js"],
    code: "https://github.com/mukhiarambhu/netmedclone",
    demo: "https://netmeds.netlify.app/",
    image:
      "https://cdn.hashnode.com/res/hashnode/image/upload/v1630088676538/aeokm9KZ7.jpeg?auto=compress,format&format=webp",
  },
  {
    id: 5,
    projectName: "Project Groww",
    projectDesc:
      "Built Backend using MongoDB used EJS for frontend . Fetched data from backend and showed on client,and also converted our whole codebase in the MVC model with the help of EJS ",
    tags: ["EJS", "Node.js", "mongoDB", "fab fa-css3"],
    logos: ["fab fa-vuejs", "fas fa-database", "fab fa-js", "fab fa-node"],
    code: "https://github.com/mukhiarambhu/Groww",
    demo: "https://growww-clone.netlify.app/",
    image:
      "https://user-images.githubusercontent.com/46128997/131253458-3b336a5c-50f2-45ba-9651-0430ebc06227.png",
  },
  {
    id: 6,
    projectName: "Project Coursera",
    projectDesc:
      "It is a project that let students search various courses offered by universities. Website is fully packed with social signup,search functionality,implemented using loacal storage. ",
    tags: ["React", "Express.js", "Node.js", "Bootstrap"],
    logos: ["fab fa-html5", "fab fa-js", "fab fa-css3"],
    code: "https://github.com/mukhiarambhu/courseera-clone",
    demo: "https://murmuring-brook-47360.herokuapp.com/",
    image:
      "https://camo.githubusercontent.com/9a8fca1af630368740f145a3feb0e7aaa5b755da750a1a56dcae67e4ecd0699d/68747470733a2f2f63646e2e686173686e6f64652e636f6d2f7265732f686173686e6f64652f696d6167652f75706c6f61642f76313632373132323436303438382f78537843446e674f792e6a7065673f6175746f3d636f6d70726573732c666f726d617426666f726d61743d77656270",
  },
  {
    id: 7,
    projectName: "Project Coursera",
    projectDesc:
      "It is a project that let students search various courses offered by universities. Website is fully packed with social signup,search functionality,implemented using loacal storage. ",
    tags: ["React", "Express.js", "Node.js", "Bootstrap"],
    logos: ["fab fa-html5", "fab fa-js", "fab fa-css3"],
    code: "https://github.com/mukhiarambhu/courseera-clone",
    demo: "https://murmuring-brook-47360.herokuapp.com/",
    image:
      "https://camo.githubusercontent.com/9a8fca1af630368740f145a3feb0e7aaa5b755da750a1a56dcae67e4ecd0699d/68747470733a2f2f63646e2e686173686e6f64652e636f6d2f7265732f686173686e6f64652f696d6167652f75706c6f61642f76313632373132323436303438382f78537843446e674f792e6a7065673f6175746f3d636f6d70726573732c666f726d617426666f726d61743d77656270",
  },
];
